import React from 'react'
import aboutbanner from '../../images/shop.png'
import aboutimg from '../../images/about.jpg'
import { Container, Row, Col} from 'react-bootstrap'

export default function About() {
  return (
<>
<div className="breadcrumb-banner" >
    <img src={aboutbanner} className="img-fluid" alt="Shop"/>
  <div className="container-bread">
       <h1 className="text-white">
        About Us
        </h1>
    </div>
  </div>


  <div className="about-box pt-5 pb-5">
    <Container fluid>
    <Row>
    <Col md={6}>

      <img src={aboutimg} className="img-fluid" alt=""/>
    
    
    </Col>

    <Col md={6}>
    <div className="aboutus-page">
    <h2>About us</h2>

    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minus facere voluptate sapiente recusandae ad, repellendus neque voluptas perspiciatis quibusdam, deleniti corrupti unde velit placeat molestias quisquam ratione similique nesciunt? Illum!</p>

    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minus facere voluptate sapiente recusandae ad, repellendus neque voluptas perspiciatis quibusdam, deleniti corrupti unde velit placeat molestias quisquam ratione similique nesciunt? Illum!</p>

    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minus facere voluptate sapiente recusandae ad, repellendus neque voluptas perspiciatis quibusdam, deleniti corrupti unde velit placeat molestias quisquam ratione similique nesciunt? Illum!</p>

    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minus facere voluptate sapiente recusandae ad, repellendus neque voluptas perspiciatis quibusdam, deleniti corrupti unde velit placeat molestias quisquam ratione similique nesciunt? Illum!</p>

    </div>


    </Col>


    </Row>

    </Container>
  </div>
  
  </>
  )
}
